export default __webpack_public_path__ + "static/media/team1.b0f88d50.png";